import * as React from 'react';

import { cn } from '@/lib/utils';

export const PageHeader = ({ className, children, ...props }: React.ComponentProps<'div'>) => {
    return (
        <div
            data-slot="page-header"
            className={cn(
                'sticky top-0 z-10 flex w-full items-center justify-between gap-3 rounded-lg border border-border bg-card px-4 py-2 shadow-xs',
                className,
            )}
            {...props}
        >
            {children}
        </div>
    );
};
